<template>
  <!--底部-->
  <div class="bottom" v-if="isShow === '联系我们'">
    <div class="contentBottom">
      <div class="contact">
        <P>江西省南昌市青山湖区京东大道1189号</P>
        <P>邮箱：yiling.wang@cnsmartwater.com</P>
        <p>电话：0791-88111096</p>
      </div>
      <div class="copyRight">
        <p>copyright©2019-2020</p>
        <p>中科水研（江西）科技股份有限公司 版权所有</p>
        <a href="https://beian.miit.gov.cn/">赣ICP备20001767号-1</a>
      </div>
    </div>
  </div>
  <div class="button2" v-else>
    <div class="copyRight">
      <p>copyright©2019-2020</p>
      <p>中科水研（江西）科技股份有限公司 版权所有</p>
      <a href="https://beian.miit.gov.cn/">赣ICP备20001767号-1</a>
      <P>江西省南昌市青山湖区京东大道1189号</P>
    </div>
  </div>
</template>
<script>
export default {
  name: "MyButton",
  data() {
    return {
      jumpPage: 0
    };
  },
  computed: {
    isShow() {
      const that = this;
      return that.$store.state.menuItem.title;
    }
  }
};
</script>
<style scoped>
@import "../assets/css/main.css";
.bottom {
  width: 100%;
  height: 380px;
  background: url(../assets/img/home/bottom-bg.png) no-repeat center;
}
.bottom .contentBottom {
  width: 1280px;
  margin: 0 auto;
  position: relative;
}
.bottom .contentBottom .contact {
  position: absolute;
  top: 250px;
  left: 760px;
}
.bottom .contentBottom .contact p {
  font-size: 18px;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
}
.bottom .contentBottom .copyRight {
  position: absolute;
  top: 336px;
  left: 0px;
  display: flex;
}
.bottom .contentBottom .copyRight p {
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
  margin-right: 10px;
}
.button2 {
  background-color: #5d5d5d;
  height: 60px;
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.button2 .copyRight {
  display: flex;
  width: 1280px;
  margin: 0 auto;
}
.button2 .copyRight p,
.button2 .copyRight a {
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
  margin-right: 10px;
  margin-top: 18px;
}
</style>
